// navbar active status shown
document.addEventListener("DOMContentLoaded", function () {
  // Get the current path, if empty string or '/' treat as home page
  const currentPage = window.location.pathname.split("/").pop() || "index.html";

  document.querySelectorAll(".nav-menu-links a").forEach((link) => {
    const href = link.getAttribute("href");
    // Remove any leading '/' from href for consistent comparison
    const cleanHref = href.replace(/^\//, "");

    // Check if either:
    // 1. It's the home page and href matches home conditions
    // 2. The href matches the current page
    if (
      (currentPage === "index.html" &&
        (cleanHref === "" || cleanHref === "index.html")) ||
      cleanHref === currentPage
    ) {
      link.classList.add("active-links");
    }
  });
});

/* ==========================================
Craft innovation video section
==========================================*/

// Get the modal elements
document.addEventListener("DOMContentLoaded", () => {
  const videoModal = document.getElementById("videoModal");
  const playbtn = document.getElementById("craft-play-btn");
  const closeBtn = document.getElementById("close-button");

  // When the user clicks the button, open the modal
  playbtn?.addEventListener("click", function () {
    videoModal.style.display = "block";
  });

  closeBtn?.addEventListener("click", function () {
    videoModal.style.display = "none";
  });
});

/* ==========================================
testimonial video reviews
==========================================*/
document.addEventListener("DOMContentLoaded", () => {
  // for first video review
  const firstVideoPlayBtn = document.getElementById("first-video-play-btn");
  const videoModal1 = document.getElementById("video-container-1");
  const CloseBtn1 = document.getElementById("testimonials-close-button-1");

  firstVideoPlayBtn?.addEventListener("click", function () {
    videoModal1.style.display = "block";
    CloseBtn1.style.display = "block";
  });

  CloseBtn1?.addEventListener("click", function () {
    videoModal1.style.display = "none";
    firstVideoPlayBtn.style.display = "block";
  });

  // for second video review
  const secondVideoPlayBtn = document.getElementById("second-video-play-btn");
  const videoModal2 = document.getElementById("video-container-2");
  const CloseBtn2 = document.getElementById("testimonials-close-button-2");

  secondVideoPlayBtn?.addEventListener("click", function () {
    videoModal2.style.display = "block";
    CloseBtn2.style.display = "block";
  });

  CloseBtn2?.addEventListener("click", function () {
    videoModal2.style.display = "none";
    CloseBtn2.style.display = "block";
  });
});

/* ==========================================
talk review video play section
==========================================*/
document.addEventListener("DOMContentLoaded", () => {
  // for first video review
  const talkPlayBtn = document.getElementById("talk-review-video-play-btn");
  const talkThumbnail = document.getElementById("talk-review-thumbnail");
  const talkContainer = document.getElementById("talk-review-video-container");
  const talkCloseBtn = document.getElementById("talk-review-video-close-btn");

  talkPlayBtn?.addEventListener("click", function () {
    talkContainer.style.display = "block";
    talkCloseBtn.style.display = "block";
    talkThumbnail.style.display = "none";
  });

  talkCloseBtn?.addEventListener("click", function () {
    talkContainer.style.display = "none";
    talkPlayBtn.style.display = "block";
    talkThumbnail.style.display = "block";
  });
});

/* ==========================================
faq accordion
==========================================*/

document.addEventListener("DOMContentLoaded", () => {
  const accordionButtons = document.querySelectorAll("[data-accordion]");

  accordionButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.preventDefault(); // Prevent default button behavior for not to reload the page

      const accordionItem = button.closest(".accordion-item");
      const accordionBody = accordionItem.querySelector(".accordion-body");

      // Close all accordion items
      accordionButtons.forEach((otherButton) => {
        if (otherButton !== button) {
          otherButton.classList.remove("active");
          const otherBody = otherButton
            .closest(".accordion-item")
            .querySelector(".accordion-body");
          otherBody.classList.remove("active");
        }
      });

      // Toggle current accordion item
      button.classList.toggle("active");
      accordionBody.classList.toggle("active");
    });
  });
});

/* ==========================================
blog pagination
==========================================*/

document.addEventListener("DOMContentLoaded", function () {
  // Get all page items
  const pageItems = document.querySelectorAll(".page-item");
  const prevButton = document.getElementById("prev-button");
  const nextButton = document.getElementById("next-button");
  const currentPageSpan = document.getElementById("current-page");
  const pageContentDivs = document.querySelectorAll(".page-content");

  // Check if pagination elements exist before proceeding
  if (!pageItems.length) {
    return;
  }

  let currentPage = 1; // Start at page 1 instead of 2
  const totalPages = pageItems.length;

  // Update active page
  function updateActivePage() {
    // Update page number indicators
    pageItems.forEach((item) => {
      const page = parseInt(item.dataset.page);
      if (page === currentPage) {
        item.classList.add("active-pagination");
        item.classList.remove("active-pagination-hover");
      } else {
        item.classList.remove("active-pagination");
        item.classList.add("active-pagination-hover");
      }
    });

    // Update current page indicator if it exists
    if (currentPageSpan) {
      currentPageSpan.textContent = currentPage;
    }

    // Show only the current page content, hide others
    pageContentDivs.forEach((content, index) => {
      if (index + 1 === currentPage) {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }
    });

    // Update button states if they exist
    if (prevButton) {
      prevButton.disabled = currentPage === 1;
      prevButton.classList.toggle("opacity-50", currentPage === 1);
    }

    if (nextButton) {
      nextButton.disabled = currentPage === totalPages;
      nextButton.classList.toggle("opacity-50", currentPage === totalPages);
    }
  }

  // Handle page item clicks
  pageItems.forEach((item) => {
    item.addEventListener("click", function () {
      currentPage = parseInt(this.dataset.page);
      updateActivePage();
    });
  });

  // Previous button
  if (prevButton) {
    prevButton.addEventListener("click", function () {
      if (currentPage > 1) {
        currentPage--;
        updateActivePage();
      }
    });
  }

  // Next button
  if (nextButton) {
    nextButton.addEventListener("click", function () {
      if (currentPage < totalPages) {
        currentPage++;
        updateActivePage();
      }
    });
  }

  // Initialize
  updateActivePage();
});

/* ==========================================
growth slider custom navigation btn
==========================================*/
document.addEventListener("DOMContentLoaded", function () {
  const swiper = document.querySelector("#growth-cards-slider");

  document.getElementById("prev-btn")?.addEventListener("click", function () {
    swiper.swiper.slidePrev();
  });

  document.getElementById("next-btn")?.addEventListener("click", function () {
    swiper.swiper.slideNext();
  });
});

// AOS
document.addEventListener("DOMContentLoaded", function() {
  AOS.init({
    duration: 800, // Adjust animation duration
    easing: "ease-in-out", // Smooth animation
    once: true, // Allow animation to trigger multiple times
    mirror: true,
  });
});
